import {
  AgxButton,
  AgxModal,
  AgxSpacer,
  AgxTypography,
  Icon_AlertCircleOutline,
  Icon_FeaturedIcon,
} from '@urbanx/agx.ui-components2';
import { CrmDisconnectedModalFields, CrmDisconnectedModalFieldValue } from './CrmDataUpdateHelper';

interface CrmDisconnectedModalProps {
  providerName?: string;
  setIsDialogOpen: (isDialogOpen: boolean) => void;
  changedFields: Map<CrmDisconnectedModalFields, CrmDisconnectedModalFieldValue>;
}

export const CrmDisconnectedModal = ({
  setIsDialogOpen,
  changedFields,
  providerName,
}: CrmDisconnectedModalProps) => {
  const modalContent = (
    <>
      <AgxSpacer
        direction="horizontal"
        contentAlignment="start"
        contentJustification="start"
        id="crm-disconnected-modal-content"
        data-testid="crm-disconnected-modal-content"
        gap="spacing-5xl"
        padding={{ top: 'md', bottom: 'md', left: 'xl', right: 'xl' }}
      >
        <AgxSpacer
          direction="vertical"
          gap="spacing-lg"
          fill
          contentAlignment="start"
          contentJustification="start"
        >
          <AgxTypography id="" type="body_ui_strong" size="medium" color="var(--text-primary)">
            {providerName ?? 'CRM'} Disconnected
          </AgxTypography>
          <AgxTypography id="" type="body" size="small" color="var(--text-primary)">
            Please update in {providerName ?? 'your CRM'} directly.
          </AgxTypography>
          <ul>
            {[...changedFields.entries()].map(([key, value]) => (
              <li key={key}>
                <AgxTypography
                  id="crm-disconnected-modal-field-label"
                  type="body"
                  size="small"
                  color="var(--text-primary)"
                >
                  {!value ? key : `${key}: ${value}`}
                </AgxTypography>
              </li>
            ))}
          </ul>
        </AgxSpacer>
      </AgxSpacer>
    </>
  );

  return (
    <AgxModal
      titleIcon={
        <Icon_FeaturedIcon
          icon={<Icon_AlertCircleOutline type="Danger" />}
          color="var(--text-error)"
          backgroundColor="var(--bg-error-light)"
        />
      }
      type="single"
      variant="withoutDivider"
      maxWidth="min(90vw, 1134px)"
      setIsDialogOpen={setIsDialogOpen}
      content={modalContent}
      actionButtonContainerStyle="withDivider"
      actionButtons={
        <AgxSpacer
          direction="horizontal"
          contentAlignment="start"
          contentJustification="center"
          gap="spacing-lg"
          style={{ width: '100%' }}
        >
          <AgxButton
            id="crm-disconnected-confirm-button"
            size="large"
            variant="primary"
            text="Confirm"
            stretch
            onClick={() => {
              setIsDialogOpen(false);
            }}
          />
        </AgxSpacer>
      }
    />
  );
};

export default CrmDisconnectedModal;
